import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FechamentoFinanceiro } from '../../models/fechamento-financeiro';

import { FechamentoFinanceiroService } from '../../services/fechamento-financeiro.service';
import { CarregandoService } from '../../services/carregando.service';
import { NotificacaoService } from '../../services/notificacao.service';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { TipoArquivo } from 'src/app/models/enum';
import { PremissasService } from 'src/app/services/premissas.service';

@Component({
  selector: 'app-cadastro-fechamento-financeiro',
  templateUrl: './cadastro-fechamento-financeiro.component.html',
  styleUrls: ['./cadastro-fechamento-financeiro.component.scss']
})
export class CadastroFechamentoFinanceiroComponent implements OnInit {
  enumStatus = [
    { id: 0, name: 'Em análise' },
    { id: 1, name: 'Aprovado' },
    { id: 2, name: 'Reprovado' },
  ];
  fechamento: FechamentoFinanceiro;
  idFechamento: string;
  selectedFile: File;
  urlRetorno: string = 'fechamento-financeiro/consulta';

  removeuAnexo = false;

  constructor(private route: ActivatedRoute, private router: Router,
    private fechamentoFinanceiroService: FechamentoFinanceiroService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private arquivoService: ArquivoService,
    private utilitarioService: UtilitarioService,
    private premissasService: PremissasService
  ) {

    if (this.router.getCurrentNavigation().extras.state) {
      this.fechamento = this.router.getCurrentNavigation().extras.state.fechamento;
      this.urlRetorno = 'fechamento-financeiro';
    }
  }

  ngOnInit(): void {

    this.carregandoService.mostra('consultarMultiFornecedores');
    this.premissasService.consultarMultiFornecedores().subscribe(f => {
      if (!f.valor) {
        this.router.navigate(['/']);
      } else {
        if (!this.fechamento) {
          if (this.route.snapshot.paramMap.get('id')) {
            this.idFechamento = this.route.snapshot.paramMap.get('id');
            this.buscarFechamento();
          } else {
            this.fechamento = new FechamentoFinanceiro();
          }
        }
      }
      this.carregandoService.esconde('consultarMultiFornecedores');
    }, (erro) => {
      this.carregandoService.esconde('consultarMultiFornecedores');
      this.notificacaoService.erro(erro);
    });


  }

  buscarFechamento() {
    this.carregandoService.mostra('buscarFechamento');

    this.fechamentoFinanceiroService.consultarPorId(Number(this.idFechamento)).subscribe(fechamento => {
      this.fechamento = fechamento;
      this.carregandoService.esconde('buscarFechamento');
    }, (erro) => {
      this.carregandoService.esconde('buscarFechamento');
      this.notificacaoService.erro(erro);
    });
  }

  onFileChanged(event: any) {
    this.selectedFile = event.target.files[0];
    this.fechamento.arquivo = this.selectedFile.name;
  }

  excluirArquivo() {
    this.selectedFile = undefined;
    this.fechamento.arquivo = '';
    this.removeuAnexo = true;
  }

  voltar() {
    this.router.navigate([this.urlRetorno]);
  }

  validarFechamento(): boolean {
    return this.fechamento.arquivo !== null && this.fechamento.arquivo !== undefined
      && this.fechamento.obs !== null && this.fechamento.obs !== undefined;
  }

  salvar() {
    this.carregandoService.mostra('salvaFechamentoFinanceiro');
    const dados = new FormData();

    if (this.selectedFile) {
      dados.append('arquivo_consulta', this.selectedFile);
      dados.append('arqui[arquivo]', this.selectedFile.name);
    } else {
      dados.append('arqui[arquivo]', this.fechamento.arquivo);
    }

    dados.append('arqui[id]', this.fechamento.id ? this.fechamento.id.toString() : '0');
    dados.append('arqui[status]', this.fechamento.status.toString());
    dados.append('arqui[obs]', this.fechamento.obs);

    if (!this.fechamento.id) {
      dados.append('arqui[data]', this.fechamento.data.toISOString());
      dados.append('arqui[dataStatus]', this.fechamento.dataStatus.toISOString());
      dados.append('arqui[idFuncionario]', this.fechamento.idFuncionario.toString());
      dados.append('arqui[idFornecedor]', this.fechamento.idFornecedor.toString());
      dados.append('arqui[valor]', this.fechamento.valor.toString());
      for (let i = 0; i < this.fechamento.pedidos.length; i++) {
        dados.append('arqui[pedidos][]', this.fechamento.pedidos[i]);
      }
    }

    this.fechamentoFinanceiroService.salvar(dados).subscribe(() => {
      this.notificacaoService.sucesso('Fechamento salvo com sucesso!!!');
      this.carregandoService.esconde('salvaFechamentoFinanceiro');
      this.router.navigate(['fechamento-financeiro/consulta']);
    }, (erro) => {
      this.carregandoService.esconde('salvaFechamentoFinanceiro');
      this.notificacaoService.erro(erro);
    });
  }

  mostrarPreview() {

    this.carregandoService.mostra('mostrarPreview');
    this.arquivoService.baixarArquivo(this.fechamento.id, TipoArquivo.Fechamento).subscribe(arq => {

      if (this.utilitarioService.ePDF(this.fechamento.arquivo)) {
        this.utilitarioService.openBlobModal(arq, this.fechamento.arquivo);
      } else if (this.utilitarioService.eImagem(this.fechamento.arquivo)) {
        this.utilitarioService.mostrarImagemBlob(arq, this.fechamento.arquivo);
      } else {
        this.utilitarioService.saveBlob(arq, this.fechamento.arquivo);
      }

      this.carregandoService.esconde('mostrarPreview');
    }, (erro) => {
      this.carregandoService.esconde('mostrarPreview');
      this.notificacaoService.erro(erro);
    });



  }

}
